import { createSlice } from '@reduxjs/toolkit';

interface Vendor {
  architect: string;
  civilEngineer: string;
  generalContractor: string;
  other: string;
  structuralEngineer: string;
}

const initialState: Vendor = {
  architect: '',
  civilEngineer: '',
  generalContractor: '',
  other: '',
  structuralEngineer: '',
};

const VendorSlice = createSlice({
  name: 'vendor',
  initialState,
  reducers: {
    set(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
});

export const { set } = VendorSlice.actions;
export default VendorSlice.reducer;
